/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgGarbage = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.5 13.621V5.25h1v8h7v-8h1v8.392l-.64.608H4.134l-.635-.629Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6 6.25h1V12H6V6.25Zm3 0h1V12H9V6.25Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M2.5 4.5h11v-1h-3V2.125L9.876 1.5H6.124l-.624.625V3.5h-3v1Zm7-2h-3v1h3v-1Z"
}));

export default SvgGarbage;